import { z } from 'zod';
import {
  channelOptions,
  daysOfWeek,
  requirementEngagementOptions,
  requirementTypeOptions,
} from '../constants';
import { validateUrl } from '../utils';

const channelValues = channelOptions.map((option) => option.value);
const engagementValues = requirementEngagementOptions.map(
  (option) => option.value
);
const typeValues = requirementTypeOptions.map((option) => option.value);

export const requirementFormSchema = z.object({
  clientName: z.string().trim().min(1, 'Client business name is required'),
  clientPOC: z.string().trim().min(1, 'Client POC is required'),
  website: z
    .string()
    .trim()
    .min(1, 'Website is required')
    .refine(validateUrl, 'Please enter a valid URL'),
  email: z.string().trim().min(1, 'Email is required').email('Please enter a valid email'),
  country: z.string().min(1, 'Country is required'),
  expectedHiringBy: z.string().optional(),
  days: z
    .array(z.enum(daysOfWeek as [string, ...string[]]))
    .min(1, 'At least one working day is required'),
  workingStart: z.string().min(1, 'Working start time is required'),
  workingEnd: z.string().min(1, 'Working end time is required'),
  priority: z.string().optional(),
  engagement: z.enum(engagementValues as [string, ...string[]], {
    errorMap: () => ({ message: 'Engagement is required' }),
  }),
  tickets: z.coerce.number().gt(0, 'Tickets per day is required'),
  comments: z.string().optional(),
  raisedBy: z.string().optional(),
  leadSource: z.string().optional(),
  timezone: z.string().min(1, 'Timezone is required'),
  languages: z.array(z.string()).optional(),
  channels: z
    .array(z.enum(channelValues as [string, ...string[]]))
    .min(1, 'At least one channel is required'),
  tools: z.array(z.string().trim().min(1)).min(1, 'At least one tool is required'),
  status: z.string().optional(),
  type: z.enum(typeValues as [string, ...string[]], {
    errorMap: () => ({ message: 'Type is required' }),
  }),
  attachmentCount: z.number().min(1, 'Attachment is required'),
});

export type RequirementFormSchemaType = z.infer<typeof requirementFormSchema>;
